import LegalPage from "./LegalPage";

export default function CookiePolicy() {
    return (
        <LegalPage title="Cookie Policy">
            <p>Il sito FitMama utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie analitici e di terze parti.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Cookie tecnici</h2>
            <p>Sono essenziali per l&apos;erogazione del servizio e non richiedono consenso.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Cookie di terze parti</h2>
            <p>Possono essere installati da servizi come Calendly, Instagram e WhatsApp quando interagisci con i relativi widget/link.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Gestione</h2>
            <p>Puoi modificare le preferenze in qualsiasi momento tramite le impostazioni del browser o cancellando il consenso salvato in questo sito.</p>
            <p className="text-sm italic mt-10">Ultimo aggiornamento: dicembre 2025.</p>
        </LegalPage>
    );
}
